import { render, staticRenderFns } from "./HomeServiceType.vue?vue&type=template&id=3caedf7a&scoped=true&"
import script from "./HomeServiceType.vue?vue&type=script&lang=js&"
export * from "./HomeServiceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caedf7a",
  null
  
)

export default component.exports